<template>
    <div>
        <validation-observer #default="{ invalid }" ref="observer">
            <span class="display-none">{{ invalid }}</span>
            <b-form ref="formular">
                <div class="white-box mt-3">
                    <div class="data-group">
                        <M3FormTitle title="Informații despre ajutoare de stat primite" :checked="completed"></M3FormTitle>
                        <div class="masura">
                            <div class="flex align-start">
                                <p class="title mb-0 mr-2">MĂSURA 1</p>
                                <p class="info mb-0">Microgranturi acordate din fonduri externe nerambursabile</p>
                            </div>

                            <div class="flex space-between align-start">
                                <div style="max-width: 700px;">
                                    <div class="status mb-4" :class="!statusM1 ?'deny':'check'">
                                        <b-icon-x-circle-fill v-if="!statusM1" font-scale="1.4" class="deny mr-2"></b-icon-x-circle-fill>
                                        <b-icon-check-circle-fill v-else font-scale="1.4" class="check mr-2"></b-icon-check-circle-fill>
                                        <span v-if="!statusM1"><strong>STATUS: Compania nu a primit ajutor de stat prin Măsura 1 <span v-if="statusM1Message.length > 0">({{ statusM1Message }})</span></strong></span>
                                        <span v-else><strong>STATUS: Compania a aplicat la ajutor de stat prin Măsura 1 <span v-if="statusM1Message.length > 0">({{ statusM1Message }})</span></strong></span>
                                    </div>
                                    <b-form-radio-group
                                        id="radio-group-1"
                                        v-model="statusM1"
                                        :options="optionsM1"
                                        name="radio-options"
                                        class="radio-check mt-2 mb-2"
                                        :disabled="completed"
                                        @change="changeStatus('m1')"
                                    ></b-form-radio-group>
                                </div>
                                <div style="width: 100%; max-width: 400px;">
                                    <div v-if="statusM1" class="inputs" >
                                        <validation-provider
                                            #default="{ errors }"
                                            rules="required"
                                            class="first-input"
                                        >
                                            <b-form-group
                                                label="Data plății ajutorului"
                                                class="has-icon"
                                            >
                                                <b-form-datepicker
                                                    id="deadlineM1"
                                                    v-model="form.help_dateM1"
                                                    class="w-100"
                                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                                    locale="ro"
                                                    placeholder="Selectează o dată"
                                                    :readonly="completed"
                                                    :class="{ 'completed': completed }"
                                                ></b-form-datepicker>
                                                <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </b-form-group>
                                        </validation-provider>
                                        <validation-provider
                                            #default="{ errors }"
                                            rules="required"
                                            class="first-input"
                                            name="valoarea ajutorului"
                                        >
                                            <b-form-group
                                                label="Valoarea ajutorului (LEI)"
                                                class="has-icon"
                                            >
                                                <b-form-input
                                                    id="name"
                                                    v-model="form.help_moneyM1"
                                                    type="number" step=".01"
                                                    name="valoare-ajutor"
                                                    :state="errors.length > 0 ? false : null"
                                                    :readonly="completed"
                                                ></b-form-input>
                                                <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </b-form-group>
                                        </validation-provider>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="masura">
                            <div class="flex align-start">
                                <p class="title mb-0 mr-2">MĂSURA 2</p>
                                <p class="info mb-0">Granturi pentru capital de lucru acordate IMM-urilor</p>
                            </div>
                            <div class="flex space-between align-start">
                                <div style="max-width: 700px;">
                                    <div class="status mt-2 mb-4" :class="!statusM2 ?'deny':'check'">
                                        <b-icon-x-circle-fill v-if="!statusM2" font-scale="1.4" class="deny mr-2"></b-icon-x-circle-fill>
                                        <b-icon-check-circle-fill v-else font-scale="1.4" class="check mr-2"></b-icon-check-circle-fill>
                                        <span v-if="statusM2"><strong>STATUS: Compania a aplicat la ajutor de stat prin Măsura 2 <span v-if="statusM2Message.length > 0">({{ statusM2Message }})</span></strong></span>
                                        <span v-else><strong>STATUS: Compania nu a primit ajutor de stat prin Măsura 2 <span v-if="statusM2Message.length > 0">({{ statusM2Message }})</span></strong></span>
                                    </div>
                                    <b-form-radio-group
                                        id="radio-group-2"
                                        v-model="statusM2"
                                        :options="optionsM2"
                                        name="radio-m2"
                                        class="radio-check mt-2 mb-2"
                                        :disabled="completed"
                                        @change="changeStatus('2')"
                                    ></b-form-radio-group>
                                </div>
                                <div style="width: 100%; max-width: 400px;">
                                    <div v-if="statusM2" class="inputs">
                                        <validation-provider
                                            #default="{ errors }"
                                            rules="required"
                                            class="first-input"
                                        >
                                            <b-form-group
                                                label="Data plății ajutorului"
                                                class="has-icon"
                                            >
                                                <b-form-datepicker
                                                    id="deadlineM2"
                                                    v-model="form.help_dateM2"
                                                    class="w-100"
                                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                                    locale="ro"
                                                    placeholder="Selectează o dată"
                                                    :readonly="completed"
                                                    :class="{ 'completed': completed }"
                                                ></b-form-datepicker>
                                                <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </b-form-group>
                                        </validation-provider>
                                        <validation-provider
                                            #default="{ errors }"
                                            rules="required"
                                            class="first-input"
                                            name="valoarea ajutorului"
                                        >
                                            <b-form-group
                                                label="Valoarea ajutorului (LEI)"
                                                class="has-icon"
                                            >
                                                <b-form-input
                                                    id="name"
                                                    v-model="form.help_moneyM2"
                                                    type="number" step=".01"
                                                    name="valoare-ajutor"
                                                    :state="errors.length > 0 ? false : null"
                                                    :readonly="completed"
                                                ></b-form-input>
                                                <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </b-form-group>
                                        </validation-provider>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="masura">
                            <div class="flex align-start">
                                <p class="title mb-0 mr-2">HORECA</p>
                                <p class="info mb-0">Sprijin financiar pentru întreprinderile din domeniul HORECA</p>
                            </div>
                            <div class="flex space-between align-start">
                                <div style="max-width: 700px;">
                                    <div class="status mt-2 mb-4" :class="!statusHoreca ?'deny':'check'">
                                        <b-icon-x-circle-fill v-if="!statusHoreca" font-scale="1.4" class="deny mr-2"></b-icon-x-circle-fill>
                                        <b-icon-check-circle-fill v-else font-scale="1.4" class="check mr-2"></b-icon-check-circle-fill>
                                        <span v-if="statusHoreca"><strong>STATUS: Compania a aplicat la ajutor de stat prin Schema Horeca <span v-if="statusHorecaMessage.length > 0">({{ statusHorecaMessage }})</span></strong></span>
                                        <span v-else><strong>STATUS: Compania nu a primit ajutor de stat prin Schema Horeca <span v-if="statusHorecaMessage.length > 0">({{ statusHorecaMessage }})</span></strong></span>
                                    </div>
                                    <b-form-radio-group
                                        id="radio-group-3"
                                        v-model="statusHoreca"
                                        :options="optionsHoreca"
                                        name="radio-horeca"
                                        class="radio-check mt-2 mb-2"
                                        :disabled="completed"
                                        @change="changeStatus('horeca')"
                                    ></b-form-radio-group>
                                </div>
                                <div style="width: 100%; max-width: 400px;">
                                    <div v-if="statusHoreca" class="inputs">
                                        <validation-provider
                                            #default="{ errors }"
                                            rules="required"
                                            class="first-input"
                                        >
                                            <b-form-group
                                                label="Data plății ajutorului"
                                                class="has-icon"
                                            >
                                                <b-form-datepicker
                                                    id="deadlineHoreca"
                                                    v-model="form.help_dateHoreca"
                                                    class="w-100"
                                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                                    locale="ro"
                                                    placeholder="Selectează o dată"
                                                    :readonly="completed"
                                                    :class="{ 'completed': completed }"
                                                ></b-form-datepicker>
                                                <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </b-form-group>
                                        </validation-provider>
                                        <validation-provider
                                            #default="{ errors }"
                                            rules="required"
                                            class="first-input"
                                            name="valoarea ajutorului"
                                        >
                                            <b-form-group
                                                label="Valoarea ajutorului (LEI)"
                                                class="has-icon"
                                            >
                                                <b-form-input
                                                    id="name"
                                                    v-model="form.help_moneyHoreca"
                                                    type="number" step=".01"
                                                    name="valoare-ajutor"
                                                    :state="errors.length > 0 ? false : null"
                                                    :readonly="completed"
                                                ></b-form-input>
                                                <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </b-form-group>
                                        </validation-provider>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="masura">
                            <div class="flex align-start">
                                <p class="title mb-0 mr-2">IMM INVEST</p>
                                <p class="info mb-0">Ajutor de stat prin Fondul Naţional de Garantare a Creditelor pentru Întreprinderile Mici si Mijlocii </p>
                            </div>
                            <p class="danger-text">Se va introduce exclusiv valoarea dobânzii și comisioanelor subvenționate</p>
                            <div class="flex space-between align-start">
                                <div style="max-width: 700px;">
                                    <div class="status mb-4 mt-2" :class="!statusIMMLocal ?'deny':'check'">
                                        <b-icon-x-circle-fill v-if="!statusIMMLocal" font-scale="1.4" class="deny mr-2"></b-icon-x-circle-fill>
                                        <b-icon-check-circle-fill v-else font-scale="1.4" class="check mr-2"></b-icon-check-circle-fill>
                                        <span v-if="!statusIMMLocal"><strong>STATUS: Compania nu a primit ajutor de stat prin IMM INVEST <span v-if="statusIMMMessageLocal.length > 0">({{ statusIMMMessageLocal }})</span></strong></span>
                                        <span v-else><strong>STATUS: Compania a aplicat la ajutor de stat prin IMM INVEST <span v-if="statusIMMMessageLocal.length > 0">({{ statusIMMMessageLocal }})</span></strong></span>
                                    </div>
                                    <b-form-radio-group
                                        id="radio-group-4"
                                        v-model="statusIMMLocal"
                                        :options="optionsIMM"
                                        name="radio-imm"
                                        class="radio-check mt-2 mb-2"
                                        :disabled="completed"
                                        @change="changeStatus('imm')"
                                    ></b-form-radio-group>
                                </div>
                                <div style="width: 100%; max-width: 400px;">
                                    <div v-if="statusIMMLocal" class="inputs">
                                        <validation-provider
                                            #default="{ errors }"
                                            rules="required"
                                        >
                                            <b-form-group
                                                label="Data plății ajutorului"
                                                class="has-icon"
                                            >
                                                <b-form-datepicker
                                                    id="deadlineIMM"
                                                    v-model="form.help_dateIMM"
                                                    class="w-100"
                                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                                    locale="ro"
                                                    placeholder="Selectează o dată"
                                                    :readonly="completed"
                                                    :class="{ 'completed': completed }"
                                                ></b-form-datepicker>
                                                <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </b-form-group>
                                        </validation-provider>
                                        <validation-provider
                                            #default="{ errors }"
                                            rules="required"
                                            name="valoarea ajutorului"
                                        >
                                            <b-form-group
                                                label="Valoarea ajutorului (LEI)"
                                                class="has-icon"
                                            >
                                                <b-form-input
                                                    id="name"
                                                    v-model="form.help_moneyIMM"
                                                    type="number" step=".01"
                                                    name="valoare-ajutor"
                                                    :state="errors.length > 0 ? false : null"
                                                    :readonly="completed"
                                                ></b-form-input>
                                                <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </b-form-group>
                                        </validation-provider>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <b-form-checkbox
                            v-model="completed"
                            switch
                            size="lg"
                            class="switch-box mt-3 mb-2"
                            @change="completeForm()"
                        >Informațiile sunt complete și corecte</b-form-checkbox>
                    </div>
                    <img src="@/assets/images/M3/M3Sketch/termenesmall.png" class="termene-icon">
                </div>

            </b-form>
        </validation-observer>
    </div>
</template>

<script>
    import { BForm, BFormInput, BFormGroup, BButton, BFormCheckbox, BIconCheckCircleFill, BIconXCircleFill, BFormRadioGroup, BFormDatepicker } from 'bootstrap-vue'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    require('@/helpers/validations/validations')
    import M3FormTitle from '../M3FormTitle'
    import axios from '@/helpers/axios'
    import api from '@/helpers/api'

    export default {
        components: {
            BForm,
            BFormInput,
            BFormGroup,
            BButton,
            BFormCheckbox,
            M3FormTitle,
            BIconCheckCircleFill,
            BIconXCircleFill,
            BFormRadioGroup,
            BFormDatepicker,
            ValidationProvider,
            ValidationObserver
        },
        props: {
            state_aids: null,
            ajutoareData: null,
            statusIMM: null,
            statusIMMMessage: null
        },
        data() {
            return {
                form: {
                    help_moneyM1: '',
                    help_dateM1: '',
                    help_moneyM2: '',
                    help_dateM2: '',
                    help_moneyHoreca: '',
                    help_dateHoreca: '',
                    help_moneyIMM: '',
                    help_dateIMM: '',
                    checked: '',
                },
                completed: false,
                caenName: '',
                options: [
                    { text: 'Proiectul vizează codul CAEN principal', value: '1' },
                    { text: 'Proiectul vizează un cod CAEN secundar eligibil  (vă rugăm selectați din lista de mai jos un cod CAEN eligibil)', value: '2' },
                ],
                status: false,
                statusM1: false,
                statusM1Message: '',
                statusM2: false,
                statusM2Message: '',
                statusHoreca: false,
                statusHorecaMessage: '',
                statusIMMLocal: false,
                statusIMMMessageLocal: '',
                data: null,
                imm: null,
                optionsM1: [
                    { text: 'Am beneficiat de ajutorul de stat prin Măsura 1', value: true },
                    { text: 'Nu am beneficiat de ajutorul de stat prin Măsura 1', value: false },
                ],
                optionsM2: [
                    { text: 'Am beneficiat de ajutorul de stat prin Măsura 2', value: true },
                    { text: 'Nu am beneficiat de ajutorul de stat prin Măsura 2', value: false },
                ],
                optionsHoreca: [
                    { text: 'Am beneficiat de ajutorul de stat prin Schema HORECA', value: true },
                    { text: 'Nu am beneficiat de ajutorul de stat prin Schema HORECA', value: false },
                ],
                optionsIMM: [
                    { text: 'Am beneficiat de ajutorul de stat prin IMM INVEST', value: true },
                    { text: 'Nu am beneficiat de ajutorul de stat prin IMM INVEST', value: false },
                ],
            }
        },
        computed: {
            checks() {
                return this.$store.getters['checks/checks'];
            },
            stateAids() {
                return this.$store.getters['stateAids/getStateAids']
            },
            allData() {
                return this.$store.getters['m3Sketch/allData']
            },
        },
        watch:{
            state_aids: {
                handler: function() {

                    this.data = this.state_aids
                    if(this.data){
                        if(this.data.help_moneyM1 && this.data.help_dateM1){
                            this.form.help_moneyM1 = this.data.help_moneyM1
                            this.form.help_dateM1 = this.data.help_dateM1
                            this.statusM1 = true;
                        }
                        if(this.data.help_moneyM2 && this.data.help_dateM2){
                            this.form.help_moneyM2 = this.data.help_moneyM2
                            this.form.help_dateM2 = this.data.help_dateM2
                            this.statusM2 = true;
                        }
                        if(this.data.help_moneyHoreca && this.data.help_dateHoreca){
                            this.form.help_moneyHoreca = this.data.help_moneyHoreca
                            this.form.help_dateHoreca = this.data.help_dateHoreca
                            this.statusHoreca = true;
                        }
                        if(this.data.help_moneyIMM && this.data.help_dateIMM){
                            this.form.help_moneyIMM = this.data.help_moneyIMM
                            this.form.help_dateIMM = this.data.help_dateIMM
                        }
                    } else {
                        this.checkStateAids()
                    }
                },
                deep: true
            },
            statusIMM: {
                handler: function() {
                    this.statusIMMLocal = this.statusIMM
                },
                deep: true,
                immediate: true
            },
            statusIMMMessage: {
                handler: function() {
                    this.statusIMMMessageLocal = this.statusIMMMessage
                },
                deep: true
            },
            checks: {
                handler: function() {
                    this.completed = this.checks.proiectulMeuAjutoareStat;
                    if(this.completed)
                        this.$emit('formComplete')
                    else
                        this.$emit('formIncomplete')
                },
                deep: true,
                immediate: true
            }
        },
        mounted() {
            this.data = this.state_aids
            if(this.data){
                if(this.data.help_moneyM1 && this.data.help_dateM1){
                    this.form.help_moneyM1 = this.data.help_moneyM1
                    this.form.help_dateM1 = this.data.help_dateM1
                    this.statusM1 = true;
                }
                if(this.data.help_moneyM2 && this.data.help_dateM2){
                    this.form.help_moneyM2 = this.data.help_moneyM2
                    this.form.help_dateM2 = this.data.help_dateM2
                    this.statusM2 = true;
                }
                if(this.data.help_moneyHoreca && this.data.help_dateHoreca){
                    this.form.help_moneyHoreca = this.data.help_moneyHoreca
                    this.form.help_dateHoreca = this.data.help_dateHoreca
                    this.statusHoreca = true;
                }
                if(this.data.help_moneyIMM && this.data.help_dateIMM){
                    this.form.help_moneyIMM = this.data.help_moneyIMM
                    this.form.help_dateIMM = this.data.help_dateIMM
                }
            }
            else {
                this.checkStateAids()
            }
        },
        methods: {
            changeStatus(stateAid){
                if(stateAid === 'm1'){
                    this.form.help_moneyM1 = 0;
                    this.form.help_dateM1 = null;
                }
                if(stateAid === 'm2'){
                    this.form.help_moneyM2 = 0;
                    this.form.help_dateM2 = null;
                }
                if(stateAid === 'horeca'){
                    this.form.help_moneyHoreca = 0;
                    this.form.help_dateHoreca = null;
                }
                if(stateAid === 'imm'){
                    this.form.help_moneyIMM = 0;
                    this.form.help_dateIMM = null;
                }
                this.statusM1Message = ''
                this.statusM2Message = ''
                this.statusHorecaMessage = ''
                this.statusIMMMessageLocal = ''
            },
            completeForm() {

                this.$refs.observer.validate().then((e) => {
                    if(!e) {
                        this.completed = false
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                    } else{
                        this.form.checked = true
                        this.stateAidsSend = {
                            state_aids: this.form,
                        }
                        this.$store.dispatch('m3Sketch/saveAllDataProjectPart', this.stateAidsSend)
                            .then((firstResponse) => {
                                this.$toast.success(firstResponse.data)

                                let formSend = {
                                    m1: this.form.help_moneyM1 ? (Number(this.form.help_moneyM1) / 4.8395).toFixed(0) : 0,
                                    m2: this.form.help_moneyM2 ? (Number(this.form.help_moneyM2) / 4.8395) .toFixed(0): 0,
                                    horeca: this.form.help_moneyHoreca ? (Number(this.form.help_moneyHoreca) / 4.9260).toFixed(0) : 0,
                                    imm: this.form.help_moneyIMM ? (Number(this.form.help_moneyIMM) / 4.8395).toFixed(0) : 0,
                                    ca: this.allData ? (Number(this.allData.turnover) / 4.946).toFixed(0) : 0
                                }
                                axios.post(api.API_ENDPOINTS.m3MaxBudget + '/' + JSON.parse(localStorage.getItem('currentM3Company')).id, formSend)
                                    .then(response => {
                                        this.maxBudget = Number(response.data.budget).toFixed(0);
                                        this.$store.dispatch('m3Sketch/setMaxBudget', this.maxBudget);
                                        this.$store.dispatch('m3Sketch/initializeIndicators');
                                    })
                            }).catch((xhr) => {
                                if (xhr.status === 422) {
                                    this.errors.record(xhr.responseJSON.errors);
                                }
                                this.$toast.error(xhr.response.data.message);
                            });
                    }
                    if(this.checks.proiectulMeuAjutoareStat !== this.completed)
                        this.$store.dispatch('checks/updateChecks', { name: 'proiectulMeuAjutoareStat', value: this.completed })
                })
            },
            checkStateAids() {
                let ajutorM1;
                let ajutorM2;
                let ajutorHoreca;
                if(JSON.parse(localStorage.getItem('currentM3Company')) && JSON.parse(localStorage.getItem('currentM3Company')).business_id){
                    ajutorM1 = this.stateAids.m1
                    ajutorM2 = this.stateAids.m2
                    ajutorHoreca = this.stateAids.horeca
                }
                /*axios.get(api.API_ENDPOINTS.m3 + JSON.parse(localStorage.getItem('currentM3Company')).business_id + '/v1')
                    .then(response => {
                        if(response.data.imminvest && response.data.imminvest[0] && response.data.imminvest[0].cui) {
                            this.statusIMM = true
                            this.statusIMMMessage = response.data.imminvest[0].stare_solicitare ? response.data.imminvest[0].stare_solicitare : ''
                        } else{
                            this.statusIMM = false
                            this.statusIMMMessage = ''
                        }
                    })*/

                if(ajutorM1) {
                    this.statusM1 = true
                    this.form.help_moneyM1 = '9679'
                    if(ajutorM1['Status contract'] === 'Acceptat de principiu in Lista de asteptare'){
                        this.statusM1Message = 'Contract semnat - în așteptare'
                    } else if(ajutorM1['Status contract'] === 'Respins In lista de asteptare'){
                        this.statusM1Message = 'Contract respins'
                        this.statusM1 = false
                    } else if(ajutorM1['Status contract'] === 'Contract semnat'){
                        this.statusM1Message = 'Contract semnat'
                    } else if(ajutorM1['Status contract'] === 'Contract platit'){
                        this.statusM1Message = 'Contract platit'
                    }else if(ajutorM1['Status contract'] === 'Respins'){
                        this.statusM1Message = 'Contract respins'
                        this.statusM1 = false
                    }
                } else {
                    this.statusM1 = false
                }
                if(ajutorM2) {
                    this.statusM2 = true
                    this.form.help_moneyM2 = ajutorM2['Suma solicitata']
                    if(ajutorM2['Status contract'] === 'Acceptat de principiu in Lista de asteptare'){
                        this.statusM2Message = 'Contract semnat - în așteptare'
                    } else if(ajutorM2['Status contract'] === 'Respins In lista de asteptare'){
                        this.statusM2Message = 'Contract respins'
                        this.statusM2 = false
                    } else if(ajutorM2['Status contract'] === 'Contract semnat'){
                        this.statusM2Message = 'Contract semnat'
                    } else if(ajutorM2['Status contract'] === 'Contract platit'){
                        this.statusM2Message = 'Contract platit'
                    }else if(ajutorM2['Status contract'] === 'Respins'){
                        this.statusM2Message = 'Contract respins'
                        this.statusM2 = false
                    }

                } else {
                    this.statusM2 = false
                }
                if(ajutorHoreca) {
                    this.statusHoreca = true
                    this.form.help_moneyHoreca = ajutorHoreca['Suma solicitata']
                    if(ajutorHoreca.Status === 'Aprobată'){
                        this.statusHorecaMessage = 'Contract aprobat'
                    } else{
                        this.statusHorecaMessage = 'Contract respins'
                        this.statusHoreca = false
                    }
                } else {
                    this.statusHoreca = false
                }

                // axios.get(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project/checks')
                //     .then( response => {
                //
                //         this.completed = JSON.parse(response.data).proiectulMeuAjutoareStat;
                //         if(this.completed)
                //             this.$emit('formComplete')
                //         else
                //             this.$emit('formIncomplete')
                //     })

            }
        }
    }
</script>

<style scoped>
.text-danger{
    width: 100%;
    white-space: pre;
}
.flex{
    display: flex;
}
.align-start{
    align-items: flex-start;
}
.space-between{
    justify-content: space-between;
}
.white-box{
    background: #fff;
    padding: 20px;
    position: relative;
}
.data-group{
    margin: auto;
    width: 85%;
}
.form-group >>> legend{
    text-align: left;
    font-size: 12px !important;
    color: #777e90;
    font-weight: 500;
}
.form-group >>> input, input{
    border-radius: 2px;
    padding: 5px 10px;
    height: inherit;
    font-size: 14px;
    max-height: 30px;
    font-weight: 700;
    color: #767a95;
    background: #e9ecef;
}
.form-group >>> input:read-only{
    background: #a1fff1;
}
.form-group >>> .form-row{
    align-items: flex-start;
}
.has-icon{
    position: relative;
}
.has-icon img{
    position: absolute;
    top: 10px;
    right: 20px;
    opacity: 0.3;
}
.caen-input p{
    text-align: right;
    font-size: 12px !important;
    color: #777e90;
    font-weight: 500;
}
.caen-input >>> label{
    font-size: 12px !important;
    color: #777e90;
    font-weight: 500;
    line-height: 23px;
}
.warn p{
    margin: 0;
    font-size: 12px;
    color: #777e90;
}
.warn p:first-child{
    font-weight: 500;
    font-size: 14px;
}
.switch-box{
    text-align: right;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.check{
    border: 1px solid #89cfc0;
    background: #49cda8;
}
.deny{
    border: 1px solid #ff6767;
    background: #ff6767;
}
.status .check{
    border-radius: 50%;
    color: #49cda8;
    background: transparent;
    border-color: transparent;
}
.status .deny{
    border-radius: 50%;
    color: #ff6767;
    background: transparent;
    border-color: transparent;
}
.masura .title{
    font-size: 14px;
    font-weight: 700;
    color: #5b6276;
    margin-bottom: 10px;
}
.masura p{
    font-size: 12px;
    color: #777e90;
    font-weight: 500;
}
.masura{
    padding-bottom: 10px;
    padding-top: 20px;
    border-bottom: 1px solid #dcdee2;
}
.masura .status{
    display: flex;
    font-size: 14px;
    margin-bottom: 44px !important;
    margin-top: 10px !important;
}
.masura .deny{
    color: #ff6767;
    background: transparent;
    border-color: transparent;
}
.masura .check{
    color: #49cda8;
    background: transparent;
    border-color: transparent;
}
.danger-text{
    font-size: 12px;
    color: #ff6767 !important;
    font-weight: 400 !important;
}
.b-form-datepicker >>> #deadlineM1, .b-form-datepicker >>> #deadlineM2, .b-form-datepicker >>> #deadlineHoreca, .b-form-datepicker >>> #deadlineIMM{
    padding: 7PX 10px;
    max-height: 30px;
}
.b-form-datepicker >>> #deadlineM1 svg, .b-form-datepicker >>> #deadlineM2 svg,  .b-form-datepicker >>> #deadlineHoreca svg, .b-form-datepicker >>> #deadlineIMM svg{
    fill: #767a95;
}
.b-form-datepicker >>> #deadlineM1__value_, .b-form-datepicker >>> #deadlineM2__value_, .b-form-datepicker >>> #deadlineHoreca__value_, .b-form-datepicker >>> #deadlineIMM__value_ {
    font-size: 12px;
    font-weight: 700;
    padding: 7px 0;
    color: #767a95;
}
.b-form-datepicker{
    color: #767a95;
    background: #e9ecef;
}
.completed{
    background: #d1f5ea!important;
    color:#b2b6be!important;
}
.radio-check >>> label{
    font-size: 14px;
    color: #767a95;
    line-height: 24px;
}
@media (max-width: 1700px){
    .white-box{
        padding: 20px 35px;
    }
}
@media (max-width: 1500px){
    .columnMobile{
        flex-direction: column;
    }
    .inputs{
        width: 80%;
        margin-top: 15px;
    }
}
</style>
